import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {predictProjectAccounts$} from './predict-project-accounts';
import type {Predict} from '@/types';

export interface UPredictAccounts {
  type: 'predict';
  data: {
    accounts: Predict[];
  };
}

export function subscribePredictProject() {
  predictProjectAccounts$
    .pipe(map<Predict[], UPredictAccounts>((accounts: Predict[]) => ({type: 'predict', data: {accounts}})))
    .subscribe((msg: UPredictAccounts) => toUiMsg$.next(msg));
}
